var map = {
	"./Speech_bubbles_nohero_1.webp": 69885,
	"./Speech_bubbles_nohero_2.webp": 75632,
	"./Speech_bubbles_nohero_3.webp": 97843,
	"./Speech_bubbles_nohero_4.webp": 73454,
	"./Speech_bubbles_nohero_5.webp": 43177,
	"./Speech_bubbles_nohero_6.webp": 48812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19174;